import { configureStore } from "@reduxjs/toolkit";
import reducer from '../reducers';

const store = configureStore({
    reducer,
    middleware: (getDefaultMiddleware: any) =>
        getDefaultMiddleware({
            thunk: {},
            serializableCheck: false,
        }),
});

export default store;

export type RootState = ReturnType<typeof store.getState>;